import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { formatApiErrorMessage } from '../../utils';
import { apiEndpoints } from '../../constants';
import { notificationAlert } from '../notifications';
import { taxUploadStoreKey } from './taxUpload.const';

export const uploadTaxes = createAsyncThunk(
  `${taxUploadStoreKey}/uploadTaxes`,
  async (body: any, thunkAPI) => {
    try {
      const response = await axios.post(apiEndpoints.payTaxes(), body);
      thunkAPI.dispatch(
        notificationAlert('Tax documents submitted', { variant: 'success' }),
      );
      return response.data;
    } catch (err: any) {
      thunkAPI.dispatch(
        notificationAlert(formatApiErrorMessage(err), {
          variant: 'error',
          persist: true,
        }),
      );
      throw new Error(err);
    }
  },
);
